import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./components/Landing";
import LandingPage from "./components/LandingPage";
import About from "./components/About";
import Properties from "./components/Properties";
// import Properties from "./components/UnderConstruction";
import Services from "./components/Services";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import PrivacyPolicy from "./components/PrivacyPolicy"
import Contact from "./components/Contact";
import TermsAndConditions from "./components/TermsConditions";

import BlogFetchDebugger from "./components/BlogFetchDebugger";
import FloatingContactActions from "./components/FloatingContactActions";

function App() {
  return (
    <Router>
      <FloatingContactActions />
      <Routes>
        <Route path="/landing" element={<Landing />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetails />} />


        <Route path="/blogfetch" element={<BlogFetchDebugger />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<div className="min-h-screen flex items-center justify-center bg-white dark:bg-slate-900 dark:bg-slate-950"><div className="text-center px-4"><h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 dark:text-slate-100 mb-4">404 - Page Not Found</h1><p className="text-gray-600 dark:text-gray-400 dark:text-slate-400">The page you're looking for doesn't exist.</p></div></div>} />
      </Routes>
    </Router>
  );
}

export default App;